import { useAppSelector } from 'store';
import { useMaintenancePolling } from 'modules/maintenance/maintenancePolling';
import { authStateSelector } from 'store/selectors/auth-selectors';
import { BrowserRouter } from 'react-router-dom';
import MaintenancePage from 'modules/maintenance/MaintenancePage';
import AppRouter from './AppRouter';
import AuthRouter from './AuthRouter';

const Router = (): JSX.Element => {
  // this step assumes the auth token must be manually set in the browser for the desired user
  const { isMaintenance } = useMaintenancePolling();
  const authStatus = useAppSelector(authStateSelector);

  if (isMaintenance) {
    return <MaintenancePage />;
  }

  return <BrowserRouter>{authStatus ? <AppRouter /> : <AuthRouter />}</BrowserRouter>;
};

export default Router;
